<template>
  <div>
    <c-card>
      <c-card-header>
        <c-icon name="cil-justify-center" />
        <strong>Bootstrap Tooltips</strong>
        <small>
          <code>v-c-tooltip</code>
          directive
        </small>
        <div class="card-header-actions">
          <a
            href="https://coreui.io/oovue/docs/directives/tooltip"
            class="card-header-action"
            rel="noreferrer noopener"
            target="_blank"
          >
            <small class="text-muted">docs</small>
          </a>
        </div>
      </c-card-header>
      <c-card-body>
        <c-row>
          <c-col col="6">
            <div class="text-center my-3">
              <c-button v-c-tooltip.hover.click="'I am a tooltip!'" color="secondary">
                Hover Me
              </c-button>
            </div>
          </c-col>
          <c-col col="6">
            <div class="text-center my-3">
              <c-button v-c-tooltip="{ content: 'I start open!', active: true }" color="secondary">
                Hover me
              </c-button>
            </div>
          </c-col>
        </c-row>
      </c-card-body>
    </c-card>
    <c-card>
      <c-card-header>
        <c-icon name="cil-justify-center" />
        <strong>Tooltips</strong>
        <small>placement</small>
      </c-card-header>
      <c-card-body>
        <div class="my-3">
          <c-row>
            <c-col v-for="placement in placements" :key="placement" md="4" class="py-4 text-center">
              <c-button
                v-c-tooltip.hover="{
                  content: `Placement ${placement}`,
                  placement,
                }"
                color="primary"
              >
                {{ placement }}
              </c-button>
            </c-col>
          </c-row>
        </div>
      </c-card-body>
    </c-card>
  </div>
</template>

<script>
export default {
  name: 'Tooltips',
  data() {
    return {
      placements: [
        'top-start',
        'top',
        'top-end',
        'bottom-start',
        'bottom',
        'bottom-end',
        'right-start',
        'right',
        'right-end',
        'left-start',
        'left',
        'left-end',
      ],
    };
  },
};
</script>
